import React from 'react';

export class NotAuthorizedScene extends React.Component {
  render() {
    return (
      <div className="content-center">
        <div className="alert alert-danger">
          You are not authorized to perform this operation.
        </div>
      </div>
    );
  }
}
